class ImagemapResizer {
  constructor({ app, mapElm, baseImgElm }) {
    this.app = app;

    this.map = mapElm;
    this.baseImg = baseImgElm;
    this.originW = Number(this.map.dataset.originW);
    this.originH = Number(this.map.dataset.originH);

    this.areas = this.map.querySelectorAll('area');
    this.areaCoordsArrs = [];
    this.areas.forEach((area) => {
      const coords = area.coords
        .replace(/ /g, '')
        .split(',')
        .map((n) => Number(n));
      this.areaCoordsArrs.push(coords);
    });

    // this.area = this.map.querySelector('area');
    // this.areaCoordsArr = this.area.coords
    //   .replace(/ /g, '')
    //   .split(',')
    //   .map((n) => Number(n));
  }

  render() {
    if (!this.app.state.isContentActive) return;

    const w = this.baseImg.getBoundingClientRect().width;
    const h = this.baseImg.getBoundingClientRect().height;
    const ratioW = w / this.originW;
    const ratioH = h / this.originH;

    this.areas.forEach((area, index) => {
      const areaNode = area;
      areaNode.coords = this.areaCoordsArrs[index]
        .map((n, i) => {
          if (i % 2 === 0) return Math.floor(n * ratioW);
          return Math.floor(n * ratioH);
        })
        .toString();
    });
  }
}

export default ImagemapResizer;
